import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  DetailTypography,
  HeroCardStack,
  ImageSection,
  TextGrid,
  TitleTypography
} from "./HeroCard.styles";
import { HeroCardProps } from "./HeroCard.types";
import { Link } from "../../components";
import { ButtonDigited } from "../../components/Button/Button.variants";
import { useNavbarStore } from "../../stores/navbarStore";

export function HeroCard({
  coverPublicURL,
  $topImageVisible,
  shortDescription,
  title,
  ...props
}: HeroCardProps) {
  const { t } = useTranslation();
  const setNavbarItem = useNavbarStore(state => state.setNavbarItem);
  const theme = useTheme();

  return (
    <HeroCardStack
      component="section"
      $coverPublicURL={ coverPublicURL }
      $topImageVisible={ $topImageVisible }
      gap={ 0 }
      { ...props }
    >
      <ImageSection $coverPublicURL={ coverPublicURL } />
      <TextGrid>
        <TitleTypography 
          sx={ {
            "&:focus": {
              outline: "none"
            },
            "&:focus-visible": {
              outline: `2px solid ${theme.customColors.backgroundPrimaryCta}`,
              outlineOffset: "2px"
            }
          } } tabIndex={ 0 } >
          { t(title) }
        </TitleTypography>
        <DetailTypography 
          sx={ {
            "&:focus": {
              outline: "none"
            },
            "&:focus-visible": {
              outline: `2px solid ${theme.customColors.backgroundPrimaryCta}`,
              outlineOffset: "2px"
            }
          } } tabIndex={ 0 } >
          { t(shortDescription) }
        </DetailTypography>
        <Link 
          role="button"
          sx={ {
            display: "inline-block", 
            width: "fit-content",         
            textDecoration: "none",        
            lineHeight: 0, 
            "&:focus": {
              border: `0.13rem solid ${theme.customColors.borderPrimaryCtaHover}`
            }, 
            "&:focus-visible": {
              outline: `2px solid ${theme.customColors.headerIcon}`,
              outlineOffset: "2px",
              margin:"3px"
            }
          } }
          aria-label={ t("go_to_explore") } href="/esplora"
          onClick={ ()=> {
            setNavbarItem("EXPLORE");
          } }
        >
          <ButtonDigited
            tabIndex={ -1 }
            typology={ "primary" }
            buttonSize="md"
            text={ t("go_to_explore") }
          />
        </Link>
      </TextGrid>

    </HeroCardStack>
  );
}
